import React from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import { PlanGetSchema } from '../../../../api/DBSchema/Plan';
import {SMCToggleSwitch} from "../../../../components/Simple/SMCToggleSwitch";

const pageSchema = PlanGetSchema.pages.general;
const pageId = pageSchema.pageId;

function PlanGeneral({
    planObject,
    setPlanData
}) {
    const { t } = useTranslation();

    const pageData = planObject[pageId];
    const setValue = (paramName, value) => {
        setPlanData([pageId, paramName], value);
    }

    const description = pageData[pageSchema.description];
    const enabled     = pageData[pageSchema.enabled];

    return (
        <EditorLayout>
            {/* Description */}
            <SMCTextInput
                label={t('SMP.DESCRIPTION')}
                value={description}
                onChange={clicked => setValue(pageSchema.description, clicked)}
            />
            {/* Enabled */}
            <SMCToggleSwitch
                label={t("SMP.ENABLED")}
                labelPosition="start"
                checked={enabled}
                onChange={clicked => setValue(pageSchema.enabled, clicked)}
            />
       </EditorLayout>
    )
}

export default PlanGeneral;